import type { GalleryMediaItem } from './media-preview-dialog';

/** One offset-paged list feeding the gallery. */
export interface GalleryPagedSource {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => Promise<unknown>;
}

/** Newest first across uploads and generated media. */
export const sortGalleryNewestFirst = (
  items: GalleryMediaItem[]
): GalleryMediaItem[] =>
  [...items].sort(
    (a, b) =>
      new Date(b.data.createdAt).getTime() -
      new Date(a.data.createdAt).getTime()
  );

export const gallerySourcesHaveMore = (sources: GalleryPagedSource[]) =>
  sources.some((source) => source.hasNextPage);

export const gallerySourcesFetching = (sources: GalleryPagedSource[]) =>
  sources.some((source) => source.isFetchingNextPage);

/** Fetch the next page of every visible source that still has one. */
export const loadMoreFromGallerySources = (sources: GalleryPagedSource[]) => {
  for (const source of sources) {
    if (source.hasNextPage && !source.isFetchingNextPage) {
      source.fetchNextPage().catch(() => {
        // The query records the error; the button stays so the user can retry.
      });
    }
  }
};
